<template>
  <navbar position="fixed" type="primary" :transparent="transparent" :color-on-scroll="colorOnScroll">
    <template slot="navbar-menu">
      <li class="nav-item mr-2">
        <a class="nav-link" @click="scrollToSection('somos')" style="cursor: pointer;">
          <img src="../assets/company.png" width="23" height="23" class="mr-1" style="margin-top: -10px"><p>¿Quiénes somos?</p> 
        </a>
      </li>
      <li class="nav-item mr-2">
        <a class="nav-link" @click="scrollToSection('enfoques')" style="cursor: pointer;">
          <img src="../assets/enfoques.png" width="23" height="23" class="mr-1" style="margin-top: -6px"><p>Soluciones y Enfoques</p> 
        </a>
      </li>
      <li class="nav-item mr-2">
        <a class="nav-link" @click="scrollToSection('giros')" style="cursor: pointer;">
          <img src="../assets/giro.png" width="23" height="23" class="mr-1" style="margin-top: -6px"><p>Giros</p> 
        </a>
      </li>
      <li class="nav-item mr-2">
        <a class="nav-link" @click="scrollToSection('marcas')" style="cursor: pointer;">
          <img src="../assets/marcas.png"  width="23" height="23" class="mr-1" style="margin-top: -6px"><p>Marcas</p> 
        </a>
      </li>
      <li class="nav-item mr-2">
        <a class="nav-link" @click="scrollToSection('mision')" style="cursor: pointer;">
          <img src="../assets/mision.png" width="23" height="23" class="mr-1" style="margin-top: -6px"><p>Misión</p> 
        </a>
      </li>
      <li class="nav-item mr-2">
        <a class="nav-link" @click="scrollToSection('vision')" style="cursor: pointer;">
          <img src="../assets/vision.png" width="23" height="23" class="mr-1" style="margin-top: -6px"><p>Visión</p> 
        </a>
      </li>
      <li class="nav-item mr-2">
        <a class="nav-link" @click="scrollToSection('valores')" style="cursor: pointer;">
          <img src="../assets/valores.png" width="23" height="23" class="mr-1" style="margin-top: -6px"><p>Valores</p> 
        </a>
      </li>
      <li class="nav-item mr-2">
        <a class="nav-link" @click="scrollToSection('politicas')" style="cursor: pointer;">
          <img src="../assets/politicas.png" width="23" height="23" class="mr-1" style="margin-top: -6px"><p>Politicas</p> 
        </a>
      </li>
      <li class="nav-item mr-2">
        <a class="nav-link btn btn-neutral" @click="scrollToSection('contacto')">
          <img src="../assets/contacto.png" width="23" height="23" class="mr-1" style="margin-top: -6px"><p>Contacto</p> 
        </a>
      </li>
      <li class="nav-item mr-2">
        <a class="nav-link" rel="tooltip" title="Follow us on Instagram" data-placement="bottom" href="https://www.instagram.com/romidamx?igsh=a3pnZWY2OWZmNGUx" target="_blank">
          <img src="../assets/instagram.png" width="23" height="23" class="mr-1" style="margin-top: -6px">
          <p class="d-lg-none d-xl-none">Instagram</p>
        </a>
      </li>
      <li class="nav-item mr-2">
        <a class="nav-link" rel="tooltip" title="Follow us on Instagram" data-placement="bottom" href="https://mx.linkedin.com/company/romidamx" target="_blank">
          <img src="../assets/linkedin.png" width="23" height="23" class="mr-1" style="margin-top: -6px">
          <p class="d-lg-none d-xl-none">Linkedin</p>
        </a>
      </li>
    </template>
  </navbar>
</template>

<script>
import { DropDown, Navbar, NavLink } from '../components';
import { Popover } from 'element-ui';
export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    Navbar,
    [Popover.name]: Popover
  },
  methods: {
    scrollToSection(section) {
      const sectionElement = document.getElementById(section); 
      if (sectionElement) {
        // Desplazarse hacia la sección deseada
        sectionElement.scrollIntoView({
          behavior: 'smooth', // Desplazamiento suave
          block: 'start'
        });
      }
    }
  }
};
</script>

<style scoped></style>
